import { graphqlOperationWithTokenRefresh } from './graphqlOperation';
import { GetG500LiteMasterInfoWithOrganizationIdQuery, QueryOutputType } from '../type/QueryType';
import { g500LiteGetType } from '../const/commonConst';
import { GetMasterInfoInput } from '../../API';

const queryGetCarInfo = /* GraphQL */ `
	query GetG500LiteMasterInfoWithOrganizationId($input: GetMasterInfoInput!) {
		getG500LiteCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
	}
`;

const queryGetDriverInfo = /* GraphQL */ `
	query GetG500LiteMasterInfoWithOrganizationId($input: GetMasterInfoInput!) {
		getG500LiteDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
	}
`;

/**
 * マスタ情報取得APIを呼び出す
 */
export const queryGetG500LiteMasterInfoWithOrganizationId = async (
	getType: (typeof g500LiteGetType)[keyof typeof g500LiteGetType],
	getMasterInfoInput: GetMasterInfoInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetG500LiteMasterInfoWithOrganizationIdQuery>> => {
	const query = getType === g500LiteGetType.carInfo ? queryGetCarInfo : queryGetDriverInfo;

	const apiResponse = await graphqlOperationWithTokenRefresh<GetG500LiteMasterInfoWithOrganizationIdQuery>(
		query,
		{ input: getMasterInfoInput },
		authorizationToken,
	);
	console.log(apiResponse);

	return apiResponse;
};
